// extracted by mini-css-extract-plugin
export default {"root":"styles__root--O3UL7"};